import React from "react";
import TimezoneList from "./List";


const Timezone = () => {
  return (
    <div>  <TimezoneList />
    </div>
  );
};

export default Timezone;
